module.exports = __webpack_public_path__ + "img/city_hops.b4e31dd6.png";